import { TAB_COMPANIES } from 'components/pages/companies/consts';
import { CONST, TAB_INVOICES_N_SUPPLIERS } from 'constants/enums';
import { template } from 'utils/helper';

export const url_companies = {
	suppliers: 'companies/suppliers/',
	supplier_find_new: 'companies/supplier/find-new/',
	supplier_create: 'companies/supplier/create/',
	supplier_get_regon_data: template`companies/supplier/${'slug'}/get-regon-data/`,
	supplier_user: template`companies/supplier/user/${'slug'}/`,
	supplier_address: template`companies/supplier/${'supplierSlug'}/address/${'slug'}/`,
	supplier_bank_account: template`companies/supplier/${'supplierSlug'}/bank-account/${'slug'}/`,
	supplier: template`companies/supplier/${'slug'}/`,
	supplier_notes: template`companies/supplier/${'slug'}/notes/`,
	supplier_set_blocked: template`companies/supplier/${'slug'}/set-blocked/`,
	supplier_fast_edit: template`companies/supplier/${'slug'}/fast-edit/`,
	check_nip: 'companies/check-nip/',
	object: template`companies/${'slug'}/`,
	linkUser: template`companies/${'slug'}/user/`,
	linkUserCompany: template`companies/${'companySlug'}/user/${'userSlug'}/`,
	list: 'companies/'
};

export const getParams = ({ page, rowsPerPage, sortParameter, isOrderByAsc, searchParameter }) => {
	const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;

	const pagination = Object.assign({},
		order && { o: order },
		// default BE pagination is 10 elements :/
		rowsPerPage ? { pageSize: rowsPerPage } : { pageSize: '100' },
		page && { page: page + 1 }
	);

	const otherParams = Object.assign({},
		searchParameter && { q: searchParameter }
	);

	return {
		...pagination,
		...otherParams
	};
};

const companies = service => ({
	deleteLinkUser: (companySlug, userSlug) => service.delete(url_companies.linkUserCompany({ companySlug, userSlug })),
	editLinkUser: ({ slug, user, ...values }) => service.put(url_companies.linkUserCompany({ companySlug: slug, userSlug: user }), values),
	addLinkUser: ({ slug, ...values }) => service.post(url_companies.linkUser({ slug }), values),
	updateCompany: ({ slug, ...values }) => service.patch(url_companies.object({ slug }), values),
	updateCompanyLogo: (slug, logo) =>  {
		const formData = new FormData();

		formData.append('logo', logo );
		return service.patch(url_companies.object({ slug }), formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});

	},
	addCertificates: ({ certFile, keyFile, bank, type, purpose }, companySlug = null) => {
		const formData = new FormData();

		formData.append('certificate', certFile, certFile.name);
		formData.append('private_key', keyFile, keyFile.name);
		if(bank) {
			formData.append('bank', bank);
		}
		if(purpose) {
			formData.append('purpose', purpose);
		}
		formData.append('type', type);

		if(companySlug) {
			formData.append('company', companySlug);
		}

		return service.post('/users/profile/certificates/', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},
	getCompany: (slug) => service.get(url_companies.object({ slug })),
	addCompany: (values) => service.post('companies/create/', values),
	findSupplier: (values) => service.post(url_companies.supplier_find_new, values),
	addSupplier: (values) => service.post(url_companies.supplier_create, values),
	forceRegonData: ({ slug }) => service.put(url_companies.supplier_get_regon_data({ slug })),
	blockUserInCompany: ({ user }) => service.put(url_companies.supplier_user({ slug: user.slug }), { isActive: !user.isActive }),
	addSupplierAddress: ({ values }) => service.post(url_companies.supplier_address({ supplierSlug: values.supplierSlug }), values),
	updateSupplierAddress: ({ values }) => service.put(url_companies.supplier_address({ supplierSlug: values.supplierSlug, slug: values.slug }), values),
	deleteSupplierAddress: ({ values }) => service.delete(url_companies.supplier_address({ supplierSlug: values.supplierSlug, slug: values.slug })),
	addSupplierBankAccount: ({ values }) => service.post(url_companies.supplier_bank_account({ supplierSlug: values.supplierSlug }), values),
	updateSupplierBankAccount: ({ values }) => service.put(url_companies.supplier_bank_account({ supplierSlug: values.supplierSlug, slug: values.slug }), values),
	deleteSupplierBankAccount: ({ values }) => service.delete(url_companies.supplier_bank_account({ supplierSlug: values.supplierSlug, slug: values.slug })),
	updateSupplierBaseInfo: ({ values }) => service.put(url_companies.supplier({ slug: values.slug }), values),
	updateSupplier: ({ slug, ...values }) => service.patch(url_companies.supplier({ slug }), values),
	getSupplierNotes: ({ slug, rowsPerPage, page }) => {
		const pagination = Object.assign({},
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);
		return service.get(url_companies.supplier_notes({ slug }), {
			params: {
				...pagination
			}
		});
	},
	getSuppliersFastEdit: ({ slug }) => service.get(url_companies.supplier_fast_edit({ slug })),
	setBlocked: (slug, shouldBlock) => service.put(url_companies.supplier_set_blocked({ slug }), { isBlocked: shouldBlock }),
	checkClientNip: (nip, currency) => service.put(url_companies.check_nip, { nip, currency }),
	updateSupplierInBuffer: ({ slug, ...invoice }) => service.patch(url_companies.supplier_fast_edit({ slug }), invoice),
	getCompanies: ({ type, page, rowsPerPage, searchParameter, additionalSearchParameter, sortParameter, isOrderByAsc }) => {
		const otherParams = Object.assign({},
			type && { type }
		);

		return service.get(url_companies.list, {
			params: {
				...getParams({ page, rowsPerPage, searchParameter, sortParameter, isOrderByAsc }),
				...otherParams
			}
		});
	},
	getCompaniesList: ({ currentTab, type, page, rowsPerPage, searchParameter, sortParameter, isOrderByAsc }) => {
		const tab = currentTab || 'all';

		const filters = {
			[TAB_COMPANIES.ALL]: {},
			[TAB_COMPANIES.ANIMATOR]: { type: 'animator' },
			[TAB_COMPANIES.OPERATOR]: { type: 'agreement-operator' },
			[TAB_COMPANIES.SELLER]: { type: 'sales-document-issuer' },
			[TAB_COMPANIES.ADMIN]: { type: 'administrator' }
		};

		const otherParams = Object.assign({},
			type && { type }
		);

		return service.get('companies/list/', {
			params: {
				...getParams({ page, rowsPerPage, searchParameter, sortParameter, isOrderByAsc }),
				...filters[tab],
				...otherParams
			}
		});
	},
	getSuppliers: ({ agreementSlug, page, rowsPerPage, currentTab, searchParameter, sortParameter, isOrderByAsc, ...additionalParams }) => {
		const params = getParams({ page, rowsPerPage, searchParameter, sortParameter, isOrderByAsc });
		const tab = currentTab || TAB_INVOICES_N_SUPPLIERS.ALL;

		const filters = {
			[TAB_INVOICES_N_SUPPLIERS.ALL]: {},
			[TAB_INVOICES_N_SUPPLIERS.BLOCKED]: { isBlocked: 1 },
			[TAB_INVOICES_N_SUPPLIERS.NO_PHONE]: { havePhone: 0, o: '-createdDate' }, // , o: '-createdDate'
			[TAB_INVOICES_N_SUPPLIERS.NO_NAME]: { haveName: 0, o: '-createdDate' } // , o: '-createdDate'
		};

		const otherParams = Object.assign({},
			agreementSlug && (agreementSlug !== CONST.ALL_SLUG_ROUTE) && { agreement: agreementSlug },
		);

		return service.get(url_companies.suppliers, {
			params: {
				...params,
				...additionalParams,
				...filters[tab],
				...otherParams
			}
		});
	},
	getSupplier: ({ slug }) => service.get(url_companies.supplier({ slug })),
	getAnimatorAgreementBankAccounts: (animatorSlug, currencyCode) => service.get(`/companies/animator/${animatorSlug}/agreement-bank-accounts/${currencyCode}/`)
});

export default companies;
